export default __webpack_public_path__ + "static/media/10.34e97c41.png";